"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResponsiveObject = exports.getResponsiveClassNames = exports.getResponsiveCustomProperties = exports.getResponsiveStyles = void 0;
const has_own_property_js_1 = require("./has-own-property.js");
const breakpoints = ['initial', 'xs', 'sm', 'md', 'lg', 'xl'];
function getResponsiveStyles({ className, customProperties, ...args }) {
    const responsiveClassNames = getResponsiveClassNames({
        allowArbitraryValues: true,
        className,
        ...args,
    });
    const responsiveCustomProperties = getResponsiveCustomProperties({ customProperties, ...args });
    return [responsiveClassNames, responsiveCustomProperties];
}
exports.getResponsiveStyles = getResponsiveStyles;
function getResponsiveClassNames({ allowArbitraryValues, value, className, propValues, parseValue = (value) => value, }) {
    const classNames = [];
    if (!value) {
        return undefined;
    }
    if (typeof value === 'string' && propValues.includes(value)) {
        return getBaseClassName(className, value, parseValue);
    }
    if (isResponsiveObject(value)) {
        const object = value;
        for (const bp in object) {
            // Make sure we are not iterating over keys that aren't breakpoints
            if (!(0, has_own_property_js_1.hasOwnProperty)(object, bp) || !breakpoints.includes(bp)) {
                continue;
            }
            const value = object[bp];
            if (value !== undefined) {
                if (propValues.includes(value)) {
                    const baseClassName = getBaseClassName(className, value, parseValue);
                    const bpClassName = bp === 'initial' ? baseClassName : `${bp}:${baseClassName}`;
                    classNames.push(bpClassName);
                }
                else if (allowArbitraryValues) {
                    const bpClassName = bp === 'initial' ? className : `${bp}:${className}`;
                    classNames.push(bpClassName);
                }
            }
        }
        return classNames.join(' ');
    }
    if (allowArbitraryValues) {
        return className;
    }
}
exports.getResponsiveClassNames = getResponsiveClassNames;
function getBaseClassName(className, value, parseValue) {
    const delimiter = className ? '-' : '';
    const matchedValue = parseValue(value);
    const isNegative = matchedValue?.startsWith('-');
    const minus = isNegative ? '-' : '';
    const absoluteValue = isNegative ? matchedValue?.substring(1) : matchedValue;
    return `${minus}${className}${delimiter}${absoluteValue}`;
}
function getResponsiveCustomProperties({ customProperties, value, propValues, parseValue = (value) => value, }) {
    let styles = {};
    // Don't generate custom properties if the value is not arbitrary
    if (!value || (typeof value === 'string' && propValues.includes(value))) {
        return undefined;
    }
    if (typeof value === 'string') {
        styles = Object.fromEntries(customProperties.map((prop) => [prop, value]));
    }
    if (isResponsiveObject(value)) {
        const object = value;
        for (const bp in object) {
            // Make sure we are not iterating over keys that aren't breakpoints
            if (!(0, has_own_property_js_1.hasOwnProperty)(object, bp) || !breakpoints.includes(bp)) {
                continue;
            }
            const value = object[bp];
            // Don't generate a custom property if the value is not arbitrary
            if (propValues.includes(value)) {
                continue;
            }
            for (const customProperty of customProperties) {
                const bpProperty = bp === 'initial' ? customProperty : `${customProperty}-${bp}`;
                styles = {
                    [bpProperty]: value,
                    ...styles,
                };
            }
        }
    }
    for (const key in styles) {
        const value = styles[key];
        if (value !== undefined) {
            styles[key] = parseValue(value);
        }
    }
    return styles;
}
exports.getResponsiveCustomProperties = getResponsiveCustomProperties;
function isResponsiveObject(obj) {
    return (typeof obj === 'object' &&
        Object.keys(obj).some((key) => breakpoints.includes(key)));
}
exports.isResponsiveObject = isResponsiveObject;
//# sourceMappingURL=responsive.js.map